<template>
  <div id="payment-form--financial-instrument">
    <v-layout row wrap>
      <v-flex xs12>
        <h2>Payment Information</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md8>
        <TextInput
          v-model="value.number"
          :validations="{ required: true, credit_card: true }"
          display-name="Card Number"
          identifier="cardNumber"
          :mask="cardNumberMask"
          ref="card-number" />
      </v-flex>

      <v-flex xs12 md4>
        <SelectInput
          v-model="value.type"
          :items="paymentTypeItems"
          :validations="{ required: true }"
          display-name="Type"
          ref="card-type" />
      </v-flex>

      <v-flex xs12 md4>
        <SelectInput
          v-model="value.month"
          :items="expirationMonthsItems"
          :validations="{ required: true, paymentCardExpiration: value.year }"
          display-name="Expiration Month"
          ref="expiration-month" />
      </v-flex>

      <v-flex xs12 md4>
        <SelectInput
          v-model="value.year"
          :items="expirationYearsItems"
          :validations="{ required: true }"
          display-name="Expiration Year"
          ref="expiration-year" />
      </v-flex>

      <v-flex xs12 md4>
        <TextInput
          v-model="value.cvv"
          :validations="{ required: true, numeric: true, max: 4, min: 3 }"
          display-name="Security Code (CVV)"
          maxlength="4"
          identifier="securityCode"
          ref="card-security-code" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SelectInput from '@/components/Shared/SelectInput.vue';
import TextInput from '@/components/Shared/TextInput.vue';
import { Months } from '@/mixins/MonthsArray';

const AMEX_PREFIX = '37';
const AMEX_MASK = '####-######-#####';
const VISA_MASK = '####-####-####-####';

export default {
  components: {
    SelectInput,
    TextInput,
  },
  props: {
    paymentTypes: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  inject: ['$validator'],
  computed: {
    cardNumberMask() {
      return this.isAmex ? AMEX_MASK : VISA_MASK;
    },
    expirationMonthsItems() {
      return Months.map(month => ({
        text: month.name,
        value: month.id,
      }));
    },
    expirationYearsItems() {
      const yearsForCCExp = 10;
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 0; i < yearsForCCExp; i += 1) {
        years.push((currentYear + i).toString());
      }
      return years;
    },
    isAmex() {
      return this.value.number
        ? this.value.number.substr(0, 2) === AMEX_PREFIX
        : false;
    },
    paymentTypeItems() {
      return this.paymentTypes.map(paymentType => ({
        text: paymentType.title,
        value: paymentType.type,
      }));
    },
  },
};
</script>
